import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface BrickQuoteApiParameter {
	type: string;
	emailTo: string;
	name: string;
	companyName: string;
	emailAddress: string;
	message: string;
}


export interface ProgramInquiryModel {

}

const programInquiryUrl = "/api/v1/communication"

export async function programInquiryService(parameter: BrickQuoteApiParameter): Promise<ServiceResult<ProgramInquiryModel>> {
	try {
		const inquiryModel = await post<ProgramInquiryModel>(`${programInquiryUrl}`, parameter as ProgramInquiryModel);
		return {
			result: inquiryModel,
			successful: true,
		};
	} catch (error) {
		if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
			return {
				successful: false,
				errorMessage: error.errorJson.message,
			};
		}
		throw error;
	}
}